
//Libraries
import { defineComponent } from "vue";

//Components
import NavBar from "../../shared/components/Nav.vue";
import BasicOptions from "./BasicOptions.vue";
import BasicInformation from "./BasicInformation.vue";
import Questions from "./Questions.vue";

export default defineComponent({
  name: "CreateModule",
  components: {
    NavBar,
    BasicOptions,
    BasicInformation,
    Questions
  },
  setup() {
    //Lifecycle Hooks

    window.scrollTo(0, 0);
  },
});
